module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/kea/~/babel-runtime/core-js/json/stringify.js
// module id = 831
// module chunks = 2